
import Properties from './Properties'
import { GongVolume, RestDoneVolume, Rounds, RoundTime, RestTime, Property } from '@/entities/Property'

export default class

  make: ->
    properties = new Properties [
      new Property().setName(GongVolume).setValue(5).setMin(1).setMax(10).setStep(1)
      new Property().setName(RestDoneVolume).setValue(5).setMin(1).setMax(10).setStep(1)
      new Property().setName(Rounds).setValue(7).setMin(1).setMax(10).setStep(1)
      new Property().setName(RoundTime).setValue(30).setMin(1).setMax(600).setStep(1)
      new Property().setName(RestTime).setValue(30).setMin(1).setMax(600).setStep(1)
    ]
    return properties.load()

